
$('.welfare-link-btn').attr('href')// window.onload = function() {
//     // 页面初始化
//     obj.init();
// }

var u = navigator.userAgent;
var config = { account: "", channel: "" };

var bindParams = {};

// var api = "https://tapi.qingcigame.com";    // 测试链接
var api = "https://api.qingcigame.com";
var shareURL = "https://snail.qingcigame.com/leading";

var obj = {
  init: function () {
    this.preloading(); // 预加载
    this.indexAjax(); // 接口请求
    this.swiper();
    this.jqslideTxtBox();
    this.indexBind(); // 所有绑定事件
    this.floatCode();
    this.copyUrl();
  },
  news: function () {
    this.indexBind(); // 所有绑定事件
    this.newsBind(); // 接口请求
    this.copyUrl();
  },
  wiki: function () {
    this.indexBind(); // 所有绑定事件
    this.wikiBind(); // 所有绑定事件
    this.copyUrl();
  },
  newsDetails: function() {
    this.indexBind(); // 所有绑定事件
    this.detailBind(); // 接口请求
    this.copyUrl();
  },
  strategy: function () {
    this.indexBind(); // 所有绑定事件
    this.strategyBind(); // 攻略绑定事件
    this.copyUrl();
  },
  welfare: function() {
    this.bannerSwiper();
  },
  welfareAct: function() {
    var id = window.location.href.split("?id=")[1];
    $('.main').addClass('main-'+id+'');
    if(id == 1) $('.welfare-link-btn').attr('href', 'https://smjh.qingcigame.com/official/news_details.html?id=687');
    if(id == 2) $('.welfare-link-btn').attr('href', 'https://smjh.qingcigame.com/official/news_details.html?id=686');    
  },
  // 图片资源预加载
  preloading: function () {
    //图片预加载
    var queue = new createjs.LoadQueue();
    queue.on("progress", function (e) {
      //加载中的进度
      // if (e.progress * 100 >= 10) {
      //   $(".loding_time span").width(parseInt(e.progress * 100) + '%')
      // };
      // var numbers = e.progress * 100;
      // console.log(numbers);

    }, this);
    queue.on("complete", function (e) {
      if (/(safari)/i.test(navigator.userAgent)) {
        $('.index').addClass('index-ios');
      }
      //加载完成执行操作
      // $('.loding_time').remove();
      // $('.preloading').addClass('preloading-ani').fadeOut(1000);
      // $('.index').removeClass('landing');
      // setTimeout(() => {
      //   $('.header_bottom').addClass('header_slide');
      // }, 500)
      // obj.swiper();
    }, this);
    queue.loadManifest([
      //加载图片，不包括后台的
      // 'images/mobile/m_jdt.png',
      // 'images/mobile/m_dt_t.png',
      // 'images/mobile/m_dt_sz.png',
      // 'images/mobile/preloading_bg.png',
      // 'images/mobile/title_img_0.png',
      // 'images/mobile/header_bg.png',
      // 'images/mobile/btn_02.png',
      // 'images/mobile/btn_01.png',
      // 'images/mobile/arrow_l_r.png',
      '/official/images/pc/main/icon/ani_01-53761776a4.png',
      '/official/images/pc/main/icon/ani_02-c9dd2fc45c.png',
      '/official/images/pc/main/icon/ani_03-faef725ac6.png',
      '/official/images/pc/main/icon/ani_04-123112f053.png',
      '/official/images/pc/main/icon/ani_05-10788a1d46.png',
      '/official/images/pc/main/mengban-291323a55e.png',
    ]);
  },
  // 所有绑定事件
  swiper: function () {
    var swiperH = new Swiper('.swiper-container-h', {
      direction: 'vertical',
      resistanceRatio: 0,
      mousewheelControl: true,
      speed: 500,
      slidesPerView: 'auto',
      onInit: function (swiper) { //Swiper2.x的初始化是onFirstInit
        swiperAnimateCache(swiper); //隐藏动画元素
        swiperAnimate(swiper); //初始化完成开始动画
        function Ani(btn, page) {
          $(btn).on('click', function () {
            swiperH.slideTo(page, 500, true);
            $('.nav-link-0'+page+'').addClass("active").siblings().removeClass("active")
          });
        };
        function navLink() {
          for (var i = 3; i >= 0; i--) {
              Ani('.nav-link-0'+i+' ', i);
          };
      } navLink();
        var aniLink01 = Ani('.ani-01', '1');
        var aniLink02 = Ani('.ani-02', '2');
        var aniLink03 = Ani('.ani-03', '3');
      },
      onSlideChangeStart(swiper) {
        swiperAnimate(swiper);
        if (swiper.activeIndex == 0) {
          obj.floatMove(false);
        }else {
          obj.floatMove(true);
        }
        let index = swiper.realIndex;
        $('.nav-link-0'+index+'').addClass("active").siblings().removeClass("active")
      },
      onSlideChangeEnd: function (swiper) {
        swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
      },
      onTouchEnd: function (swiper) {
        swiperAnimate(swiper);
      },
    });
  },
  bannerSwiper: function() {
    var swiperB = new Swiper('.swiper-banner',{
      loop: true,
      slidesPerView: "auto",
      effect: 'horizontal',
      centeredSlides: true,
      autoplayDisableOnInteraction: false,
      autoplay: 3000,
      pagination : '.swiper-pagination',
      paginationClickable :true,
    })
    var swiperC = new Swiper('.swiper-banner-02',{
      loop: true,
      slidesPerView: "auto",
      effect: 'horizontal',
      centeredSlides: true,
      autoplayDisableOnInteraction: false,
      autoplay: 2000,
      pagination : '.swiper-pagination',
      paginationClickable :true,
    })
  },
  // 游戏下载浮窗
  floatCode: function () {

    // 下载链接
    $('.btn_box').on('click', "a", function () {
      var className = $(this).attr('class');
      console.log(className)
      var game_id = 67;
      $.ajax({
        type: "get",
        url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
        dataType: 'json',
        success: function (json) {
          if (className.indexOf('appStore') !== -1) {
            // ios
            if (json.data.ios_down_url == '') {
              layer.msg('ios下载暂未开放，敬请期待！<br/>', { time: 3000 });
            } else {
              window.open(json.data.ios_down_url)
            }
          } else if (className.indexOf('android') !== -1) {
            // 安卓
            if (json.data.android_download_url == '') {
              layer.msg('安卓下载暂未开放，敬请期待！<br/>', { time: 3000 });
            } else {
              var type  = window.location.href.split('?type=')[1];
              if(type) {
                console.log(type)
                let url = "https://download4.qcplay.com/apk/" + type + ".apk"
                window.open(url)
                return
              }else {
                window.open(json.data.android_down_url)
              }
            }
          } else if(className.indexOf('taptap') !== -1){
            window.open("https://tap.cn/Qjrq12rV?channel=rep-rep_ivz0jz2dvgg")
          }else {
            // 好有快爆
            window.open("https://www.3839.com/a/96030.htm?from=hykb")
          }
        }
      })
    });

    // var iosUrl = 'https://apps.apple.com/cn/app/id1507966188';
    // var andUrl = 'http://download2.qcplay.com/snail/apk/snail_qc_official_0.1.40.apk'; 

    // $('.float-code .app-btn').attr('href', iosUrl);
    // $('.float-code .and-btn').attr('href', andUrl);


    var index = layer.load(2, { shade: [0.1, '#fff'] });
    $.ajax({
      url: "https://api.qingcigame.com/web/configInfo",
      type: "GET",
      xhrFields: {
        withCredentials: true
      },
      success: function (json) {
        if (json.code == 200) {
          // QQ:
          $.each(json.data.list.QQ, function (index, values) {
            var mengxinHtml = '<li><p>' + values + '</p></li>';
            $('.right-QQ ul').append(mengxinHtml);
          });
          // 公众号
          $('.hidden-code-box .code-gzh img').attr('src', json.data.official_account_image);
          // 微博
          $('.hidden-code-box .code-gfwb img').attr('src', json.data.micro_blog);
          // b博
          $('.hidden-code-box .code-gfbb img').attr('src', json.data.b_blog);
          // 逗音
          $('.hidden-code-box .code-gfdy img').attr('src', json.data.tiktok);
          // 客服
          $('.hidden-service-box .code-img img').attr('src', json.data.customer_service_image);
          // 公众号：
          $('.hidden-service-box .gzh').html(json.data.official_account);
          // 邮箱
          $('.hidden-service-box .email').html(json.data.email);
          layer.close(index);
        } else {
          layer.msg("服务器请求失败", { time: 2000 });
          layer.close(index);
        }
      }, error: function () {
        layer.msg("服务器请求失败", { time: 2000 });
        layer.close(index);
      }
    })

    $('.nav-link-off-02').click(function (event) {
      layer.msg("暂未开放，敬请期待!", { time: 2000 });
    });
  },

  share: function () {
    $.ajax({
      url: api + "/wechat/jssdk",
      type: "POST",
      data: {
        uri: window.location.href,
      },
      success: function (json) {

        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          wx.config(json.data);
          wx.ready(function () {
            wx.updateAppMessageShareData({
              title: '最强蜗牛', // 分享标题
              desc: '大家都爱玩的沙雕手游', // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
              success: function () { }
            })

            wx.updateTimelineShareData({
              title: '最强蜗牛-大家都爱玩的沙雕手游', // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
              success: function () {
                // 设置成功
              }
            })
          });
          return;
        } else {
          try {
            setShareInfo({
              title: '最强蜗牛', // 分享标题
              summary: '大家都爱玩的沙雕手游', // 分享内容
              pic: 'https://static.qcplay.com/common/snail_icon.png', // 分享图片
              url: window.location.href, // 分享链接
              // 微信权限验证配置信息，若不在微信传播，可忽略
              WXconfig: {
                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                appId: json.data.appId, // 公众号的唯一标识
                timestamp: json.data.timestamp, // 生成签名的时间戳
                nonceStr: json.data.nonceStr, // 生成签名的随机串
                signature: json.data.signature // 签名
              }
            });
          } catch (err) { }
        }
      }
    })
  },

  // 游戏咨询信息切换
  jqslideTxtBox: function() {
  $(".slideTxtBox").slide({ effect: "leftLoop", trigger: "click", easing: "easeOutElastic" });
  $(".slideTxtBox2").slide({ effect: "leftLoop", trigger: "click", easing: "easeOutElastic" });
  },

  indexBind: function () {

    //主页悬浮框
    $(".changes-btn").on('click', function () {
      if ($(this).hasClass("on")) {
        obj.floatMove(true)
      } else {
        obj.floatMove(false)
      }
    })
   
    // 第三方页面跳转
    $('.link-a').click(function (event) {
      var _this = $(this).attr('data');
      window.location.replace(_this);
    });

    // 主页 属性/技能 和 故事 切换
    $(".right_part .tabbar ul li").on('click', function() {
      $(this).addClass("on").siblings().removeClass("on")
      let index = $(this).attr("id")
      $(".shell ." + index + "").addClass("active").siblings().removeClass("active")
    })

    //适龄弹窗
    $(".year_box").click(function () {
      $(".year_pop").fadeIn();
    });

     //适龄弹窗
     $(".simulator").click(function() {
      $(".simulator_pop").fadeIn();
    });

    // 点击弹窗背景关闭弹窗
    $('.close_bg, .close_wrapper').click(function (event) {
      $('.popup, .popup_wrap').fadeOut();
    });

    // 关闭下载提示
    $('.download-wrap').on('click', function () {
      $(this).fadeOut();
    });

    $('.wx-btn').click(function (event) {
      $('.share-wrap .popup_content').addClass('popup_content-ani');
    });

    $('.close_bg').click(function (event) {
      setTimeout(function () {
        $('.share-wrap .popup_content').removeClass('popup_content-ani');
        $('.share-wrap').removeClass('gzh-wrap')
      }, 500);
    });

    $('.btn-1').click(function (event) {
      $('.share-wrap').fadeIn();
    });

    $('.btn-2').click(function (event) {
      $('.share-wx-wrap').fadeIn();
    });

  },

  indexAjax: function () {

    var index = layer.load(2, { shade: [0.1, '#fff'] });

    // 初始文章数据
    this.onAjax({
      url: `${api}/familiar/index`,
      type: 'GET',
      data: {
        limit: 6,
      },
      xhrFields: {
        withCredentials: true
    },
      success: function (res) {
        if (res.code == 200) {
          layer.close(index);
          $(".swiper-banner .swiper-wrapper .swiper-slide").remove();
          $(".swiper-banner-02 .swiper-wrapper .swiper-slide").remove();
          // 报社 攻略的数据
          var data = res.data.articleList || {};
          const dataMap = {
            'new': 'news',
            'newest': 'latest',
            'activity': 'strategy',
            'sprout_new': 'introduction',
            'strategy': 'activity'
          }
          console.log(data)
          for (let i in data) {
            let node = ''
            data[i].forEach(element => {
              let label = "";
              switch(element.cate_id) {
                case 58: label = "新闻";break;
                case 57: label = "活动";break;
                case 53: label = "萌新";break;
                case 54: label = "进阶";break;
              }
              node += `
              <li>
                <a href="news_details.html?id=${element.id}">
                  <div class="column">
                  <span>${label} | ${element.article_title}</span>
                  </div>
                </a>
              </li>`
            })
            $(`.${dataMap[i]}`).append(node)
          }
          // 推荐板块数据
          const {newest_banner, banner} = data;
          var list = {
            newest_banner,
            banner
          }
          const bannerMap = {
            "newest_banner": "swiper-banner",
            "banner": "swiper-banner-02",
          }
          for(let i in list) {
            let bannerNode = ""
            list[i].forEach((item)=>{
              bannerNode += `
              <div class="swiper-slide">
                <a href="news_details.html?id=${item.id}">
                  <img class="banner_img" src="${item.index_pc_img}" title="公告" />
                  <div class="bottom_box">
                    <div class="banner_title">
                      <span>${item.article_title}</span>
                    </div>
                    <div class="blur_bg"></div>
                  </div>
                </a>
              </div>
            `
            })
            $(`.${bannerMap[i]} .swiper-wrapper`).append(bannerNode)
          }
          // dom插入完成后 再初始化推荐板块的swiper 
          obj.bannerSwiper();
        }
      },
      error: function (json) {
        layer.msg("服务器请求失败", { time: 2000 });
      },
      complete: function () {
        layer.close(index);
      }
    });

    // 初始图鉴数据
    function wikiDetail(id) {
      var index = layer.load(2, { shade: [0.1, '#fff'] });
      obj.onAjax({
        url: `${api}/familiar/monster/show/`,
        type: 'GET',
        data: {
          id: id
        },
        success: function (res) {
            $(".skill_box ul li").remove();
          if (res.code == 200) {
            console.log(res)
            layer.close(index);
            var data = res.data.content[0] || {};
            $("#name").html(data.name)
            $("#sort").html(data.type)
            $("#type").html("所属: " + data.attribute_name)
            $("#race").html("种族: " + data.race)
            $("#tag").html("技能: " + data.tag)
            let list = [];
            data.story.forEach((item)=> {
              list.push("<div style='text-indent: 30px'>" + item + "</div>")
            })
            $("#storeContent").html(list)
            // 技能遍历
            const {skill} = data;
            let node = "";
            skill.forEach((element, index)=> {
              if(!element.skill_icon_id) return
              let itemNode = ""
              // 技能等级遍历
              element.skill_level.forEach((item, current)=> {
                itemNode += `
                <div>${item ? (current + 1) + "级:" + item : ""}</div>
                `
              })
              node += `
              <li id="s${index + 1}" class="skill" >
                <img style="border-radius: 5px;overflow: hidden;" src="https://download4.qcplay.com/smjh/applets/skill/${element.skill_icon_id}.png" alt="技能图标">
                <div class="skill_pop s${index + 1} swiper-no-swiping">
                  <div class="skill_content">
                    <div class="skill_wrap">
                      <div class="skill_name">${element.skill_name}</div>
                      <div class="skill_attr">
                        <div class="skill_type">技能类型: ${element.skill_type}</div>
                        <div class="skill_type">技能等级: 1/${element.skill_level.length}级</div>
                        <div class="skill_type">冷却时间: ${element.consume_round}s</div>
                        <div class="consumption_type">消耗能量: ${element.consumption_type}</div>
                      </div>
                      <div class="skill_detail">
                        <div class="skill_describe">${element.skill_describe}</div>
                        <div class="skill_level">
                          ${itemNode}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              `
            })
            $(".skill_box ul").append(node)
  
          }
        },
        error: function (json) {
          layer.msg("服务器请求失败", { time: 2000 });
        },
        complete: function () {
          layer.close(index);
        }
      });
    }
    // 初始请求 火龙的图鉴
    wikiDetail(142);

    // 主页角色切换
    $(".character_box ul li").on("click", function () {
      let a = $(this).index() + 1;
      let id = $(this).attr("data-id");
      // 防抖
      if($(this).parent().hasClass("buffering") || $(this).hasClass("selected")) return false
      if (a == 6) {
        window.location.href = "wiki.html"
        return false
      }
      $(this).parent().addClass("buffering");
      $(this).addClass("selected").siblings().removeClass("selected");
      $(".role_box").addClass("show");
      $(".right_part").addClass("fadeRight");
      setTimeout(() => {
        $(".role_box .role").attr("class", "role role_0" + a);
      }, 250)
      setTimeout(() => {
        $(".role_box").removeClass("show");
        $(".right_part").removeClass("fadeRight");
        $(this).parent().removeClass("buffering")
      }, 500)
      // 故事的滚动条置顶
      let bg = document.getElementById("callScroll")
      bg.scrollTo(0, 0);
      // 复位
      $("#attr").addClass("on").siblings().removeClass("on");
      $(".shell .attr ").addClass("active").siblings().removeClass("active");
      // 数据请求
      wikiDetail(id);
    })
  },
  // 获取报社列表
  newsBind: function () {
    // 第三方页面跳转
    $('.tab_bar ul li').click(function (event) {
      let cate_id = $(this).attr("data-id")
      if($(this).hasClass("active")) return false
      $(this).addClass("active").siblings().removeClass("active")
      window.location.href = window.location.href.split("?")[0]+'?limit=10&cate_id='+cate_id+'&page=1'
    });

    var current = window.location.href.split("?")[0];
    var index = layer.load(2, { shade: [0.1, '#fff'] });
    var type = "0";
    var page  = this.getQueryVariable('page');
    var cate_id  = this.getQueryVariable('cate_id');
    $("#b" + cate_id + "").addClass("active").siblings().removeClass("active")

    this.onAjax({
      url: `${api}/familiar/index`,
      type: 'GET',
      data: {
        page: page,
        type: type,
        limit: 10,
        cate_id: cate_id
    },
      success: function (res) {
        if (res.code == 200) 
        var current_page = res.data.articleList.current_page;  // 当前页数
        var last_page = res.data.articleList.last_page;        // 总共页数
        var prev_page_url = res.data.articleList.prev_page_url;// 前一页
        var next_page_url = res.data.articleList.next_page_url;// 后一页{
          layer.close(index);
          console.log(res)
          // 翻页功能
          // obj.pageDown(last_page, next_page_url, 'id');
          var data = res.data.articleList.data || {};
          console.log(data)
          let node = ''
          data.forEach(element => {
            node += `
            <a class="content" href="news_details.html?id=${element.id}">
              <div class="content_wrap">
                <div class="content_bg">
                  <div class="banner_bg">
                    <img class="banner_img" src="${element.index_pc_img}" alt="图片">
                  </div>
                  <div class="article_bg">
                    <div class="title_box">
                      <div class="title">
                        <div class="tag">${element.cate_id == 0 ? "最新" : (element.cate_id == 58 ? "新闻" : "活动")}</div>
                        <text>${element.article_title}</text>
                      </div>
                      <div class="created_time">${element.created_at}</div>
                    </div>
                    <div class="article_detail">${element.article_excerpt}</div>
                  </div>
                </div>
              </div>
              <div class="active_bg"></div>
          </a>
          `
          })
          $(".common_list").append(node)

          $('.current_page').html(current_page);      // 当前页数
          $('.last_page').html(last_page);            // 总共页数
          if(prev_page_url === null) {                // 上一页
              $('.front-link').addClass("disabled"); // 没有第一页
              $('.front-link').attr('href',"javascript:;")
          } else {
              $('.front-link').removeClass("disabled");
              $('.front-link').attr('href', current+'?cate_id='+cate_id+'&page='+prev_page_url.split("?page=")[1])
          }
          if(next_page_url === null) {                // 下一页
              $('.after-link').addClass("disabled");
              $('.after-link').attr('href',"javascript:;")
          } else {
              $('.after-link').removeClass("disabled");
              $('.after-link').attr('href', current+'?cate_id='+cate_id+'&page='+next_page_url.split("?page=")[1])        
          }
        
      },
      error: function (json) {
        layer.msg("服务器请求失败", { time: 2000 });
      },
      complete: function () {
        layer.close(index);
      }
    });


  },
  // 翻页功能
  pageDown: function(lastPage, nextPage, cite) {
    var href = window.location.href.split("?")[0] + '?'+cite+'='
    console.log(href)
    // console.log(lastPage);
    // console.log(nextPage);

    // if(lastPage !== '') $('.prev-page').addClass('show').attr('href', href+lastPage.id).attr('title', lastPage.article_title);
    // if(nextPage !== '') $('.next-page').addClass('show').attr('href', href+nextPage.id).attr('title', nextPage.article_title);
  },
  // 文章详情相关功能
  detailBind: function () {
    var id = this.getQueryVariable('id');
    var index = layer.load(2, { shade: [0.1, '#fff'] });
    this.onAjax({
      url: `${api}/web/article/${id}`,
      type: 'GET',
      success: function (res) {
        $('.details .main .main_wrap').addClass('main-show');
        if (res.code == 200) {
          console.log(res)
          layer.close(index);
          var data = res.data.list || {};
          const {one_level_name, cate_name, article_title, created_at, article_content} = res.data.list || {};

          $('.main_wrap .sort_01').html(one_level_name);
          $('.main_wrap .sort_02').html(cate_name);
          $('.news_title .title').html(article_title);
          $('.news_title .time').html(created_at);
          $('.main_wrap iframe').attr('src', 'news-iframe.html?id='+id);

          // 根据分类 导航栏对应变化
          if(data.one_level_name == "使魔攻略" ) {
            $(".tabbar ul li:nth-child(5)").addClass("active")
            $('.main_wrap .sort_01').attr("href", "strategy.html?page=1&limit=10&cate_id=53");
          }else {
            $(".tabbar ul li:nth-child(2)").addClass("active")
            $('.main_wrap .sort_01').attr("href", "news.html?page=1&limit=10&cate_id=0");
          }
          if(data.one_level_name == "使魔公益") {
            $(".tabbar ul li:nth-child(3)").addClass("active").siblings().removeClass('active');
            $('.main_wrap .sort_01').attr("href", "javascript:;");
          }
            

          // 获取当前ifname子页面的高度
          function iframeAutoFit(iframeObj){ 
            setTimeout(() => {
              if(!iframeObj) return;
              iframeObj.height = (iframeObj.Document ? iframeObj.Document.body.scrollHeight+20 : iframeObj.contentDocument.body.offsetHeight+20)
            },500) 
          }
          $('#external-frame').load(function(){ //  等iframe加载完毕       
              let obj = document.getElementById('external-frame')
              iframeAutoFit(obj);
              layer.close(index);
              $("#external-frame").contents().find('.iframe').append(article_content);   
          });

        }
      },
      error: function (json) {
        layer.msg("服务器请求失败", { time: 2000 });
      },
      complete: function () {
        layer.close(index);
      }
    });
  },
  // 攻略相关功能
  strategyBind: function () {
    // 攻略切换
    $('.tab_bar ul li').click(function (event) {
      let cate_id = $(this).attr("data-id")

      if($(this).hasClass("active")) return false
      window.location.href = window.location.href.split("?")[0]+'?limit=10&cate_id='+cate_id+'&page=1'
    });
    
    var index = layer.load(2, { shade: [0.1, '#fff'] });
    var page  = this.getQueryVariable('page');
    var current = window.location.href.split("?")[0];
    var cate_id  = this.getQueryVariable('cate_id');
    $("#b" + cate_id + "").addClass("active").siblings().removeClass("active")
    this.onAjax({
      url: `${api}/familiar/index`,
      type: 'GET',
      data: {
        page: page,
        limit: 10,
        cate_id: cate_id
    },
      success: function (res) {
        if (res.code == 200) 
        var current_page = res.data.articleList.current_page;  // 当前页数
        var last_page = res.data.articleList.last_page;        // 总共页数
        var prev_page_url = res.data.articleList.prev_page_url;// 前一页
        var next_page_url = res.data.articleList.next_page_url;// 后一页{
          layer.close(index);
          console.log(res)
          // 翻页功能
          // obj.pageDown(res.data.last, res.data.next, 'id');
          var data = res.data.articleList.data || {};
          console.log(data)
          let node = ''
          let label = cate_id == 53 ? "萌新" : "进阶"
          data.forEach(element => {
            node += `
            <a class="content" href="news_details.html?id=${element.id}">
              <div class="content_wrap">
                <div class="content_bg">
                  <div class="label">${label}</div>
                  <div class="article_bg">
                    <div class="title_box">
                      <div class="title">
                        <text>${element.article_title}</text>
                      </div>
                    </div>
                    <div class="article_detail">${element.article_excerpt}</div>
                  </div>
                </div>
              </div>
              <div class="active_bg"></div>
          </a>
          `
          })
          $(".common_list").append(node)
          $('.current_page').html(current_page);      // 当前页数
          $('.last_page').html(last_page);            // 总共页数
          if(prev_page_url === null) {                // 上一页
            $('.front-link').addClass("disabled"); // 没有第一页
            $('.front-link').attr('href',"javascript:;")
        } else {
            $('.front-link').removeClass("disabled");
            $('.front-link').attr('href', current+'?cate_id='+cate_id+'&page='+prev_page_url.split("?page=")[1])
        }
        if(next_page_url === null) {                // 下一页
            $('.after-link').addClass("disabled");
            $('.after-link').attr('href',"javascript:;")
        } else {
            $('.after-link').removeClass("disabled");
            $('.after-link').attr('href', current+'?cate_id='+cate_id+'&page='+next_page_url.split("?page=")[1])        
        }
      },
      error: function (json) {
        layer.msg("服务器请求失败", { time: 2000 });
      },
      complete: function () {
        layer.close(index);
      }
    });
    
  },

  // 图鉴相关功能
  wikiBind: function() {
    var attribute_id = "";       // 使魔属性
    var name         = "";       // 使魔姓名
    var type         = "";       // 使魔种类
    // 图鉴数据拉取
    function wikiAjax(page) {
      var index = layer.load(2, { shade: [0.1, '#fff'] });
      obj.onAjax({
        url: `${api}/familiar/monster/list/`,
        type: 'GET',
        data: {
          limit: 15,
          page: page,
          attribute_id: attribute_id,
          name: name,
          type: type
        },
        success: function (res) {
            $(".wiki_box ul li").remove();
          if (res.code == 200) {
            console.log(res)
            layer.close(index);
            var data = res.data.data || {};
            var current_page = res.data.current_page;  // 当前页数
            var last_page = res.data.last_page;        // 总共页数
            var prev_page_url = res.data.prev_page_url;// 前一页
            var next_page_url = res.data.next_page_url;// 后一页{
            
            let node = "";
            data.forEach((element)=> {
              node += `
                <li id="${element.id}">
                  <img width="128px" height="128px" src="https://download4.qcplay.com/smjh/applets/pic/${element.avatar_id}.png">
                </li>
              `
            })
            $(".wiki_box ul").append(node)
            $('.current_page').html(current_page);      // 当前页数
            $('.last_page').html(last_page);            // 总共页数
            if(prev_page_url == null) {     
                         // 上一页
                $('.front-link').addClass("disabled"); // 没有第一页
            } else {
                $('.front-link').removeClass("disabled");
                $('.front-link').attr('data-page', prev_page_url.split("?page=")[1])
            }
            if(next_page_url == null) {                // 下一页
                $('.after-link').addClass("disabled");
            } else {
                $('.after-link').removeClass("disabled");
                $('.after-link').attr('data-page', next_page_url.split("?page=")[1])       
            }
  
          }
        },
        error: function (json) {
          layer.msg("服务器请求失败", { time: 2000 });
        },
        complete: function () {
          layer.close(index);
        }
      });
    }

    // 初始图鉴拉取
    wikiAjax(1);

    // 图鉴详情数据拉取
    function wikiDetail(id) {
      var index = layer.load(2, { shade: [0.1, '#fff'] });
      obj.onAjax({
        url: `${api}/familiar/monster/show/`,
        type: 'GET',
        data: {
          id: id
        },
        success: function (res) {
            // $(".wiki_box ul li").remove();
          if (res.code == 200) {
            console.log(res)
            layer.close(index);
            var data = res.data.content[0] || {};
            $("#name").html(data.name)
            $("#sort").html(data.type)
            $("#type").html("所属: " + data.attribute_name)
            $("#race").html("种族: " + data.race)
            $("#tag").html("技能: " + data.tag)
            let list = [];
            data.story.forEach((item)=> {
              list.push("<div style='text-indent: 30px'>" + item + "</div>")
            })
            $("#storeContent").html(list)
            $(".item_wrap .avatar img").attr("src", "https://download4.qcplay.com/smjh/applets/pic/" + data.avatar_id + ".png")
            // 技能遍历
            const {skill} = data;
            let node = "";
            skill.forEach((element, index)=> {
              if(!element.skill_icon_id) return
              let itemNode = ""
              // 技能等级遍历
              element.skill_level.forEach((item, current)=> {
                itemNode += `
                <div>${item ? (current + 1) + "级:" + item : ""}</div>
                `
              })
              node += `
              <li id="s${index + 1}" class="skill" >
                <img style="border-radius: 5px;overflow: hidden;" src="https://download4.qcplay.com/smjh/applets/skill/${element.skill_icon_id}.png" alt="使魔头像">
                <div class="skill_pop s${index + 1} swiper-no-swiping">
                  <div class="skill_content">
                    <div class="skill_wrap">
                      <div class="skill_name">${element.skill_name}</div>
                      <div class="skill_attr">
                        <div class="skill_type">技能类型: ${element.skill_type}</div>
                        <div class="skill_type">技能等级: 1/${element.skill_level.length}级</div>
                        <div class="skill_type">冷却时间: ${element.consume_round}s</div>
                        <div class="consumption_type">消耗能量: ${element.consumption_type}</div>
                      </div>
                      <div class="skill_detail">
                        <div class="skill_describe">${element.skill_describe}</div>
                        <div class="skill_level">
                          ${itemNode}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              `
            })
            $(".skill_box ul").append(node)
  
          }
        },
        error: function (json) {
          layer.msg("服务器请求失败", { time: 2000 });
        },
        complete: function () {
          layer.close(index);
        }
      });
    }

    // 图鉴弹窗打开
    $(".wiki_box ul").on('click', "li", function() {
      let id = $(this).attr("id");
      // 数据请求
      wikiDetail(id);
      // 弹窗打开
      $(".wiki_pop").fadeIn();
      // 故事的滚动条置顶
      let bg = document.getElementById("callScroll")
      bg.scrollTo(0, 0);
      // 一打开就定位在技能
      $("#attr").addClass("on").siblings().removeClass("on");
      $(".attr_bg .attr ").addClass("active").siblings().removeClass("active");
    })

    // 图鉴弹窗关闭
    $(".wiki_pop .close_bg").on("click", function() {
      $(".skill_box ul li").remove();
    })

    // 分类切换
    $(".sort_list ul li").on('click',function() {
      $(this).addClass("selected").siblings().removeClass("selected")
      getData();
      wikiAjax(1);
    })

    // 搜索按钮点击
    $(".search_btn").on('click', function() {
      search();
    })

    // 键盘回车搜索
    document.onkeydown = function(event) {
      var e = event || window.event || arguments.callee.caller.arguments[0]
      if(e.keyCode == 13) {
        search();
      }
    }
    
    // 搜索事件
    function search() {
      getData();
      wikiAjax(1);
    }
    
    // 获取参数
    function getData() {
      attribute_id = $("#sortAttr ul").find(".selected").attr("data");
      type      = $("#sortType ul").find(".selected").attr("data");
      name      = $("#searchData").val();
    }

    // 复位清除选项
    $('.clear_btn').click(function(event) {
      $('.sort_list ul li:nth-child(1)').addClass('selected').siblings().removeClass('selected');
      attribute_id = "";       // 使魔属性
      name         = "";       // 使魔姓名
      type         = "";       // 使魔种类
      wikiAjax(1)
    });
    
    // 弹窗内 技能 和 故事 切换
    $(".attr_bg .tabbar ul li").on('click', function() {
      $(this).addClass("on").siblings().removeClass("on")
      let index = $(this).attr("id")
      $(".attr_bg ." + index + "").addClass("active").siblings().removeClass("active");
    })
    
    // 点击分页图鉴拉取
    $('.front-link, .after-link').on('click', function() {
      let page = $(this).attr("data-page");
      $(".wiki_box ul li").remove();
      // $("#sortAttr ul li").hasClass("selected").find("span").html;
      setTimeout(()=> {
        wikiAjax(page);
      }, 300)
    })

  },

  // 悬浮窗口动效
  floatMove: function (status) {
    if (status) {
      $(".float_box").addClass("float-code-ani")
      $(".changes-btn").removeClass("on");
      $(".changes-btn").addClass("off");
    } else {
      $(".float_box").removeClass("float-code-ani")
      $(".changes-btn").removeClass("off");
      $(".changes-btn").addClass("on");
    }
  },
 
  copyUrl: function () {
    $('.copy-btn').html(window.location.href)
    var clipboard = new Clipboard('.copy-btn');
    clipboard.on('success', function (e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      layer.msg('复制成功', { time: 3000 });
      e.clearSelection();
    });

    clipboard.on('error', function (e) {
      console.error('Action:', e.action);
      console.error('Trigger:', e.trigger);
    });
  },
  // 获取当前hash的具体参数
  getQueryVariable: function (variable) {
    var query = window.location.href.split('?')[1];
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return (false);
  },
  // 简易封装常用ajax
  onAjax: function (options) {
    const { url, type, success, error, data } = options;
    $.ajax({
      url: url,
      type: type,
      data: data,
      success: function (json) {
        if (json.code !== 200) {
          var message = json.message;
          layer.msg(message);
          return false;
        }
        success && success(json);
      },
      error: function (err) {
        layer.msg(err.message);
        error && error(err);
      }
    });
  },
  newYearTime: function () {
    var date = {
      isDuringDate: function (beginDateStr, endDateStr) {
        var curDate = new Date(),
          beginDate = new Date(beginDateStr),
          endDate = new Date(endDateStr);
        if (curDate >= beginDate && curDate <= endDate) {
          $('.li-07, .li-08').removeClass('change-off');
          return true;
        }
      }
    };
    date.isDuringDate('2021/02/12', '2022/02/12');
  }
}